import { render, staticRenderFns } from "./cForm.vue?vue&type=template&id=2c76a968&"
import script from "./cForm.vue?vue&type=script&lang=js&"
export * from "./cForm.vue?vue&type=script&lang=js&"
import style0 from "./cForm.vue?vue&type=style&index=0&id=2c76a968&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports